import TextHeading from "components/TextHeading";
import TagStatus from "components/TagStatus";
import { TStatus } from "utils/InterfaceAndTypeGeneral";

interface IHeaderSummaryProps {
  isMobile: boolean;
  titleSummary: string;
  statusSummary: TStatus;
  isVisibleStatus: boolean;
}
const HeaderSummary = ({
  isMobile,
  titleSummary,
  statusSummary,
  isVisibleStatus,
}: IHeaderSummaryProps) => {
  const containerClass = `${isMobile ? "flex-col" : "items-center gap-6"} flex`;
  const tagStatusClass = isMobile ? "my-6" : "my-8";

  return (
    <div className={containerClass}>
      <TextHeading
        text={titleSummary}
        className={!isVisibleStatus ? tagStatusClass : ""}
      />
      {isVisibleStatus && (
        <div className={tagStatusClass}>
          <TagStatus type={statusSummary} />
        </div>
      )}
    </div>
  );
};

export default HeaderSummary;
